class PageParamBuilder {
  constructor() {
    this.page = null
    this.size = null
    this.count = null
    this.sortList = []
  }

  buildParam() {
    let res = ''

    if (this.page) {
      res += `page=${this.page}`
    }
    if (this.size) {
      if (res.length) {
        res += '&'
      }
      res += `size=${this.size}`
    }

    if (this.sortList.length) {
      for (let i = 0; i < this.sortList.length; i += 1) {
        if (res.length) {
          res += '&'
        }
        res += `sort=${this.sortList[i]}`
      }
    }
    return res
  }

  getSortListItemAsObject() {
    if (this.sortList.length > 0) {
      const sortStringAsArray = this.sortList[0].split(',')
      const headerName = sortStringAsArray[0]
      const direction = sortStringAsArray[1]
      return { headerName, direction }
    }
    return { headerName: '', direction: '' }
  }
}

export default PageParamBuilder
